module.exports = __webpack_public_path__ + "img/3.295a7233.svg";